import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import enLocale from '@mgm/common/locale/en.locale';
import esLocale from '@mgm/common/locale/es.locale';

// Check localStorage for a saved language preference
const savedLanguage = localStorage.getItem('i18nextLng') || 'en'; // Default to 'en' if no saved language

// Set the default locale for Moment.js
moment.locale(savedLanguage);

// Optional: Set a default timezone for Moment.js
const defaultTimezone = savedLanguage === 'es' ? 'Europe/Madrid' : 'America/New_York'; // Example timezones
moment.tz.setDefault(defaultTimezone);

const resources = {
  en: {
    ...enLocale,
  },
  es: {
    ...esLocale,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: 'en', // default language
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    detection: {
      order: ['localStorage', 'navigator'],
      // Keys or params to lookup language from
      lookupLocalStorage: 'i18nextLng',
    },

  });

i18n.on('languageChanged', (lng) => {
  moment.locale(lng);
  // Optionally, set a default timezone for each locale
  const timezone = lng === 'es' ? 'Europe/Madrid' : 'America/New_York'; // Example timezones
  moment.tz.setDefault(timezone);
});

export default i18n;
